
import * as bWFwbGlicmUtZ2w from 'maplibre-gl';
import * as d2FzbTpqcy1zdHJpbmc from './drive-drive-web-app.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_bWFwbGlicmUtZ2w_ = bWFwbGlicmUtZ2w;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.css.display_$external_prop_getter' : (_this) => _this.display,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.textAlign_$external_prop_setter' : (_this, v) => _this.textAlign = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.transform_$external_prop_setter' : (_this, v) => _this.transform = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.stopPropagation_$external_fun' : (_this, ) => _this.stopPropagation(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.getMethodImplForStorage' : (obj, key) => { return obj[key]; },
    'org.w3c.dom.setMethodImplForStorage' : (obj, key, value) => { obj[key] = value; },
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.reload_$external_fun' : (_this, ) => _this.reload(),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
    'org.w3c.dom.onclick_$external_prop_setter' : (_this, v) => _this.onclick = v,
    'org.w3c.dom.oninput_$external_prop_setter' : (_this, v) => _this.oninput = v,
    'org.w3c.dom.setTimeout_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.setTimeout(p0, isDefault0 ? undefined : p1, ...p2, ),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_(()->Js?)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Js?)'](f, )),
    'org.w3c.dom.clearTimeout_$external_fun' : (_this, p0, isDefault0) => _this.clearTimeout(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.className_$external_prop_setter' : (_this, v) => _this.className = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.innerHTML_$external_prop_setter' : (_this, v) => _this.innerHTML = v,
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.remove_$external_fun_1' : (_this, p0) => _this.remove(...p0),
    'org.w3c.dom.toggle_$external_fun' : (_this, p0, p1, isDefault0) => _this.toggle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.checked_$external_prop_getter' : (_this) => _this.checked,
    'org.w3c.dom.checked_$external_prop_setter' : (_this, v) => _this.checked = v,
    'org.w3c.dom.max_$external_prop_setter' : (_this, v) => _this.max = v,
    'org.w3c.dom.min_$external_prop_setter' : (_this, v) => _this.min = v,
    'org.w3c.dom.placeholder_$external_prop_setter' : (_this, v) => _this.placeholder = v,
    'org.w3c.dom.step_$external_prop_setter' : (_this, v) => _this.step = v,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.value_$external_prop_getter' : (_this) => _this.value,
    'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.selectedIndex_$external_prop_getter' : (_this) => _this.selectedIndex,
    'org.w3c.dom.selectedIndex_$external_prop_setter' : (_this, v) => _this.selectedIndex = v,
    'org.w3c.dom.HTMLSelectElement_$external_class_instanceof' : (x) => x instanceof HTMLSelectElement,
    'org.w3c.dom.HTMLSelectElement_$external_class_get' : () => HTMLSelectElement,
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'com.optersoft.drive.geo.epochMillisDouble' : () => Date.now(),
    'com.optersoft.drive.geo.importModule' : (url) => window.__driveImport(url),
    'com.optersoft.drive.geo.callDefaultInit' : (mod) => mod.default(),
    'com.optersoft.drive.geo.newDriveCoreHandle' : (mod, camerasJson, roadsJson) => new mod.DriveCore(camerasJson, roadsJson),
    'com.optersoft.drive.geo.coreQuery' : (core, lat, lon, hasHeading, heading, speedMps, maxDistanceM, headingToleranceDeg, hasCorridor, corridorM) => core.query(lat, lon, hasHeading, heading, speedMps, maxDistanceM, headingToleranceDeg, hasCorridor, corridorM),
    'com.optersoft.drive.geo.coreSnapInfo' : (core, lat, lon, hasHeading, heading) => core.snap_info(lat, lon, hasHeading, heading),
    'com.optersoft.drive.geo.coreFree' : (core) => { core.free() },
    'org.maplibre.kmp.js.geometry.LngLat_$external_fun' : (p0, p1) => new _ref_bWFwbGlicmUtZ2w_.LngLat(p0, p1),
    'org.maplibre.kmp.js.geometry.x_$external_prop_getter' : (_this) => _this.x,
    'org.maplibre.kmp.js.geometry.y_$external_prop_getter' : (_this) => _this.y,
    'org.maplibre.kmp.js.map.pitch_$external_prop_setter' : (_this, v) => _this.pitch = v,
    'org.maplibre.kmp.js.map.bearing_$external_prop_setter' : (_this, v) => _this.bearing = v,
    'org.maplibre.kmp.js.map.center_$external_prop_setter' : (_this, v) => _this.center = v,
    'org.maplibre.kmp.js.map.zoom_$external_prop_setter' : (_this, v) => _this.zoom = v,
    'org.maplibre.kmp.js.map.padding_$external_prop_setter' : (_this, v) => _this.padding = v,
    'org.maplibre.kmp.js.map.duration_$external_prop_setter' : (_this, v) => _this.duration = v,
    'org.maplibre.kmp.js.map.padding_$external_prop_setter_1' : (_this, v) => _this.padding = v,
    'org.maplibre.kmp.js.map.Map_$external_fun' : (p0) => new _ref_bWFwbGlicmUtZ2w_.Map(p0),
    'org.maplibre.kmp.js.map.setStyle_$external_fun' : (_this, p0) => _this.setStyle(p0),
    'org.maplibre.kmp.js.map.getBearing_$external_fun' : (_this, ) => _this.getBearing(),
    'org.maplibre.kmp.js.map.getZoom_$external_fun' : (_this, ) => _this.getZoom(),
    'org.maplibre.kmp.js.map.jumpTo_$external_fun' : (_this, p0) => _this.jumpTo(p0),
    'org.maplibre.kmp.js.map.easeTo_$external_fun' : (_this, p0) => _this.easeTo(p0),
    'org.maplibre.kmp.js.map.getCanvas_$external_fun' : (_this, ) => _this.getCanvas(),
    'org.maplibre.kmp.js.map.on_$external_fun' : (_this, p0, p1) => _this.on(p0, p1),
    'org.maplibre.kmp.js.map.once_$external_fun' : (_this, p0, p1) => _this.once(p0, p1),
    'org.maplibre.kmp.js.map.project_$external_fun' : (_this, p0) => _this.project(p0),
    'org.maplibre.kmp.js.map.container_$external_prop_setter' : (_this, v) => _this.container = v,
    'org.maplibre.kmp.js.map.setAttributionControlFalse' : (opts) => { opts.attributionControl = false },
    'org.maplibre.kmp.js.map.setEasing' : (opts, easing) => { opts.easing = easing },
    'org.maplibre.kmp.js.map.__convertKotlinClosureToJsClosure_((Double)->Double)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Double)'](f, p0)),
    'org.maplibre.kmp.js.util.emptyJsObject' : () => ({}),
    'com.optersoft.drive.web.jsonNumberField' : (json, field) => (function(){try{var v=JSON.parse(json)[field];return typeof v==='number'?v:NaN;}catch(e){return NaN;}})(),
    'com.optersoft.drive.web.newAudioContext' : () => (function(){try{return new (window.AudioContext||window.webkitAudioContext)();}catch(e){return null;}})(),
    'com.optersoft.drive.web.audioCurrentTime' : (ctx) => ctx.currentTime,
    'com.optersoft.drive.web.scheduleBeep' : (ctx, freq, vol, startT, stopT) => { (function(){var osc=ctx.createOscillator();var gain=ctx.createGain();osc.type='sine';osc.frequency.value=freq;gain.gain.value=vol;osc.connect(gain);gain.connect(ctx.destination);osc.start(startT);osc.stop(stopT);})() },
    'com.optersoft.drive.web.speakUtterance' : (text, lang, vol) => { (function(){var s=window.speechSynthesis;if(!s)return;var u=new SpeechSynthesisUtterance();u.text=text;u.lang=lang||'es-ES';u.volume=vol;s.speak(u);})() },
    'com.optersoft.drive.web.jsEventSource' : (url) => new EventSource(url),
    'com.optersoft.drive.web.esOnIncidents' : (es, handler) => es.addEventListener('incidents', (e) => handler(e.data)),
    'com.optersoft.drive.web.esClose' : (es) => es.close(),
    'com.optersoft.drive.web.geolocationAvailable' : () => (!!(window.navigator && window.navigator.geolocation)),
    'com.optersoft.drive.web.startWatch' : (cb) => (window.navigator.geolocation.watchPosition(function(p){var c=p.coords;cb(c.latitude, c.longitude, (c.heading==null?NaN:c.heading), (c.speed==null?NaN:c.speed));},function(e){},{ enableHighAccuracy: true, maximumAge: 1000 })),
    'com.optersoft.drive.web.__convertKotlinClosureToJsClosure_((Double,Double,Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3) => wasmExports['__callFunction_((Double,Double,Double,Double)->Unit)'](f, p0, p1, p2, p3)),
    'com.optersoft.drive.web.clearWatch' : (id) => { window.navigator.geolocation.clearWatch(id) },
    'com.optersoft.drive.web.setMapLayer' : (map, id, geojson, layerJson) => { 
            (function(){
              var data = JSON.parse(geojson);
              var src = map.getSource(id);
              if (src) { src.setData(data); return; }
              map.addSource(id, { type: 'geojson', data: data });
              var spec = JSON.parse(layerJson);
              spec.id = id; spec.source = id;
              map.addLayer(spec);
            })()
             },
    'com.optersoft.drive.web.jsonStringifyJs' : (s) => JSON.stringify(s),
    'com.optersoft.drive.web.startRecorder' : (onReady, onBlob, onError) => { 
            (function(){
              var nav = window.navigator;
              if (!nav || !nav.mediaDevices) { onError('Micrófono no disponible'); return; }
              nav.mediaDevices.getUserMedia({ audio: true }).then(function(stream){
                var chunks = [];
                var mr = new MediaRecorder(stream);
                var ctx = { mr: mr, stream: stream };
                mr.ondataavailable = function(e){ chunks.push(e.data); };
                mr.onstop = function(){
                  try { onBlob(new Blob(chunks, { type: 'audio/mp4' })); } catch (e) { onBlob(null); }
                };
                mr.start();
                ctx.timer = window.setTimeout(function(){ try { mr.stop(); } catch(e){} }, 60000);
                onReady(ctx);
              }, function(err){ onError('No se pudo acceder al micrófono'); });
            })()
             },
    'com.optersoft.drive.web.__convertKotlinClosureToJsClosure_((Js?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Unit)'](f, p0)),
    'com.optersoft.drive.web.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'com.optersoft.drive.web.recorderStop' : (recorder) => { (function(){ try { if (recorder.timer) window.clearTimeout(recorder.timer); recorder.mr.stop(); } catch(e){} })() },
    'com.optersoft.drive.web.recorderCleanup' : (recorder) => { (function(){ try { if (recorder.timer) window.clearTimeout(recorder.timer); if (recorder.stream) recorder.stream.getTracks().forEach(function(t){ t.stop(); }); } catch(e){} })() },
    'com.optersoft.drive.web.uploadReport' : (apiOrigin, body, blob, onDone) => { 
            (function(){
              window.fetch(apiOrigin + '/report', {
                method: 'POST', headers: { 'content-type': 'application/json' }, body: body
              }).then(function(r){ return r.json(); }).then(function(j){
                var id = j && j.id;
                if (id && blob) {
                  window.fetch(apiOrigin + '/report-audio?id=' + encodeURIComponent(id), { method: 'POST', body: blob });
                }
                onDone(true);
              }, function(e){ onDone(false); });
            })()
             },
    'com.optersoft.drive.web.__convertKotlinClosureToJsClosure_((Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Boolean)->Unit)'](f, p0)),
    'com.optersoft.drive.web.jsFetch' : (url) => window.fetch(url),
    'com.optersoft.drive.web.responseOk' : (resp) => (!!resp.ok),
    'com.optersoft.drive.web.responseText' : (resp) => resp.text(),
    'com.optersoft.drive.web.jsCaches' : () => (window.caches || null),
    'com.optersoft.drive.web.cachesOpen' : (caches, name) => caches.open(name),
    'com.optersoft.drive.web.cacheMatch' : (cache, url) => (cache.match(url)),
    'com.optersoft.drive.web.cachePut' : (cache, url, resp) => cache.put(url, resp.clone()),
    'com.optersoft.drive.web.encodeURIComponentJs' : (s) => encodeURIComponent(s)
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
};
    